// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig: {
    apiKey: "AIzaSyABa2n-PNSagbG9rNR8DFWnOe4zMn-UYpc",
    authDomain: "takeanumber-tech.firebaseapp.com",
    databaseURL: "https://takeanumber-tech.firebaseio.com",
    projectId: "takeanumber-tech",
    storageBucket: "takeanumber-tech.appspot.com",
    messagingSenderId: "448352748642",
    appId: "1:448352748642:web:696cc96ce79f6034afbd3b",
    measurementId: "G-FWPK9Y68TW"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
